export enum Timers {
    Flags = 0,
    HeadAnimation1 = 1,
    ArmsAnimation1 = 2,
    ArmsAnimation2 = 3,
    Step1 = 4,
    Spline1 = 5,
    Spline2 = 6,
    Spline3 = 7,
    Wings = 8,
    BirdsFly = 9,
    WindMove1 = 10,
    WindMove2 = 11,
    WindMove3 = 12,
    Fade = 13,
    Camera = 14
}
